<template>
    <div class="datepicker" :class="{ 'datepicker--overdue' : isOverdue }">
        <input ref="input" type="text" :value="job.required_at" class="datepicker__input" />

        <button v-if="job.required_at" @click.prevent="open" href="#" class="lc-open-date pill">
            <icon type="calendar" color="bluegray" />
            <span class="pill__label">
                Due <span class="lc-date-highlight datepicker__highlight">{{ job.required_at | formattedDate(format) }}</span>
            </span>
            <icon @click.native.stop="clear" type="close" color="bluegray" size="14" class="lc-remove-date" />
        </button>

        <button v-else @click.stop="open" class="lc-no-date pill">
            <icon type="calendar" color="bluegray" size="16" />
            <icon type="plus" color="bluegray" size="14" />
        </button>
    </div>
</template>
<script>
import moment from 'moment'
import flatpickr from 'flatpickr'
import Icon from './Icon'
import { mapState } from 'vuex'

export default {
    data () {
        return {
            datepicker: null,
            format: app.config.SHORT_DATE
        }
    },

    mounted () {
        this.datepicker = flatpickr(this.$refs.input, {
            onChange: this.onChange,
            disableMobile: 'true'
        })
    },

    methods: {
        onChange (selectedDates, dateStr, instance) {
            this.$store.dispatch('job/saveDueDate', dateStr)
        },

        open () {
            this.datepicker.open()
        },

        clear () {
            this.datepicker.clear()
            this.datepicker.jumpToDate()
        }
    },

    computed: {
        ...mapState('job', ['job']),

        isOverdue () {
            return moment().diff(this.job.required_at, 'hours') > 0
        }
    },

    components: {
        Icon
    }
}
</script>
